module.exports = __webpack_public_path__ + "static/media/moe-2024.e3f13cfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/moe-2024.jpg
// module id = 67
// module chunks = 0